import { render, staticRenderFns } from "./authentication-guide-card.vue?vue&type=template&id=7fab001e&scoped=true"
import script from "./authentication-guide-card.vue?vue&type=script&lang=js"
export * from "./authentication-guide-card.vue?vue&type=script&lang=js"
import style0 from "./authentication-guide-card.vue?vue&type=style&index=0&id=7fab001e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab001e",
  null
  
)

export default component.exports